import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface UpsertQuilttAccountBody {
    id: string; // For Grove, we only allow updating existing addresses for now.
    userId: string;
    name?: string;
    description?: string;
    interestRate?: number;
    minimumPayment?: number;
    holisticCategory?: string;
    isHidden?: boolean;
}

const useUpsertQuilttAccount = requestBuilder.mutation<
    AccountSummary,
    UpsertQuilttAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/quiltt',
    method: 'POST',
});

export const useUpsertQuilttAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpsertQuilttAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const upsertQuilttAccountAsync = async (body: UpsertQuilttAccountBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertQuilttAccountAsync,
    };
};
